export function formatGameStatusLabel(status: string): string {
  switch (status) {
    case 'completed':
      return 'Selesai';
    case 'in_progress':
      return 'Berlangsung';
    default:
      return 'Belum Main';
  }
}

export function formatSetPair(setsWon: number, setsLost: number): string {
  return `${setsWon}-${setsLost}`;
}

export function formatPointPair(pointsScored: number, pointsConceded: number): string {
  return `${pointsScored}-${pointsConceded}`;
}

export function formatWinRatePercent(winRate: number): string {
  return `${Math.round(winRate)}%`;
}

export function formatPlayerFormat(fmt: string): string {
  return fmt === 'doubles' ? 'Ganda' : 'Tunggal';
}

export function playersLabel(players: { playerName: string }[]): string {
  return players.map((p) => p.playerName).join(' & ') || '-';
}
